import { ACTIONS } from '../config/const.config';
import useAccess from './access.hook';

const useFilteredActions = (module, actions) => {
  const { hasOperationAccess, hasAdminAccess } = useAccess();

  return actions.filter((action) => {
    if (
      action.action === ACTIONS.VIEW.value ||
      action.action === ACTIONS.PLAY_VIDEO.value ||
      action.action === ACTIONS.PREVIEW.value ||
      action.action === ACTIONS.VIEW_SUBSCRIBERS.value ||
      action.action === ACTIONS.VIEW_SUBSCRIPTION.value ||
      action.action === ACTIONS.SUBSCRIPTIONS_HISTORY.value
    ) {
      return hasOperationAccess(module, 'view');
    }
    if (
      action.action === ACTIONS.EDIT.value ||
      action.action === ACTIONS.CHANGE_PASSWORD.value
    ) {
      return hasOperationAccess(module, 'edit');
    }
    if (action.action === ACTIONS.DELETE.value) {
      return hasOperationAccess(module, 'delete');
    }
    if (
      action.action === ACTIONS.MANAGE_VIDEOS.value ||
      action.action === ACTIONS.MANAGE_EPISODES.value ||
      action.action === ACTIONS.GENERATE_ROKU_FEED.value ||
      action.action === ACTIONS.REGENERATE_CACHE.value ||
      action.action === ACTIONS.ASSIGN_CHANNELS.value ||
      action.action === ACTIONS.COPY_CHANNEL.value ||
      action.action === ACTIONS.CREATE_SUBSCRIPTION.value ||
      action.action === ACTIONS.EDIT_SUBSCRIPTION.value ||
      action.action === ACTIONS.REMOVE_SUBSCRIPTION.value ||
      action.action === ACTIONS.CANCEL_SUBSCRIPTION.value ||
      action.action === ACTIONS.MANAGE_EDITS.value ||
      action.action === ACTIONS.MANAGE_ORDER.value
    ) {
      return hasOperationAccess(module, 'manage');
    }
    if (
      action.action === ACTIONS.REPROCESS_VIDEO.value ||
      action.action === ACTIONS.REPROCESS_TRAILER.value
    ) {
      return hasAdminAccess();
    }

    return true;
  });
};

export default useFilteredActions;
